export const requiredRule = v => !!v || 'Обязательное поле';
